module.exports = __webpack_public_path__ + "static/media/logo.e9ff8fd9.svg";